<template>
   <div>
       <div v-if="referenceInfo.length">
           <div v-if="!showDetail" style="font-size: 14px;">
               <div class="item">
                   <div>随访任务</div>
                   <div>随访时间</div>
                   <div>最后随访状态</div>
                   <div>质控情况</div>
               </div>
               <div @click="getHistoryDetail(item.taskId)" class="item" v-for="(item,index) in referenceInfo" :key="index">
                   <div class="cursor">【{{item.taskId}}】-{{item.taskName}}</div>
                   <div class="cursor">{{item.createTime.split(' ')[0]}}</div>
                   <div class="cursor">{{getFollowUpState(item.followupState)}}</div>
                   <div class="cursor">{{item.isQuality? "已质控":"未质控"}}</div>
               </div>
           </div>
           <div v-else>
               <div style="text-align: left;">
                   <el-button type="primary" size="mini" @click="showDetail = false">返回</el-button>
               </div>
               <div v-for="(item,index) in detail" :key="index">
                   <div style="text-align:left;padding: 15px;">{{item.header}}</div>
                   <div class="item" v-for="(_item,_index) in item.followupInfoKV" :key="_index">
                       <div>{{_item.infoKey}}</div>
                       <div>{{_item.infoValue}}</div>
                   </div>
               </div>
           </div>
       </div>
       <template v-else>
        <span class="no-data">
            <p>暂无历史随访</p>
            <img src="./img/no-result.png" alt="暂无就诊数据"/>
        </span>
       </template>
   </div>
</template>

<script>
    import {RestReferenceControllerGetAllFollowupList,RestReferenceControllerGetDeliver} from "@src/assets/js/api.js"
    export default {
        name: "followupHistoryList",
        props: ['patientData'],
        data() {
            return {
                referenceInfo: [],
                detail: [],
                showDetail: false
            }
        },
        mounted() {
            this.getReferenceInfo()
        },
        methods: {
            getReferenceInfo() {
                this.getReferenceInfoAsync()
                    .then(res => {
                        this.referenceInfo = res.retValue
                    })
                this.$forceUpdate()
            },
            getHistoryDetail(taskId) {
                this.getHistoryDetailAsync({taskId: taskId})
                    .then(res => {
                        this.detail = res.retValue
                        this.showDetail = true
                    })
            },
            getFollowUpState (state) {
                switch (state) {
        case 0:
          return '数据初始化'
          break
        case 1:
          return '短信随访待开始'
          break
        case 2:
          return '短信发送1次'
          break
        case 3:
          return '短信发送2次'
          break
        case 4:
          return '短信随访失败'
          break
        case 5:
          return '短信随访成功'
          break
        case 6:
          return '电话随访待开始'
          break
        case 7:
          return '电话随访进行中'
          break
        case 8:
          return '电话随访稍后拨打'
          break
        case 9:
          return '电话随访成功'
          break
        case 10:
          return '电话随访失访'
          break
        case 11:
          return '旧数据（原拒随）'
          break
        case 12:
          return '死亡'
          break
        case 13:
          return '异常号码'
          break
        case 16:
          return '沟通不畅'
          break
        case 17:
          return '拒绝随访（有信息）'
          break
        case 18:
          return '拒绝随访（无信息）'
          break
      }
            },
            //===========================req================================
            async getReferenceInfoAsync() {
                let request = new RestReferenceControllerGetAllFollowupList()
                request.p_followupPatientId = this.patientData.followupPatientId
                await request.send()
                return request.result
            },
            async getHistoryDetailAsync(p) {
                let request = new RestReferenceControllerGetDeliver()
                request.p_taskId = p.taskId
                request.p_followupPatientId = this.patientData.followupPatientId
                await request.send()
                return request.result
            }
        },
    }
</script>

<style lang="scss" scoped>
    .item {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 15px;
        border-bottom: 1px solid #ccc;
        .cursor {
            cursor: pointer;
            color: #248cfa;
        }
        div {
            width: 30%;
            text-align: center;
        }
        &:last-child {
            border-bottom: none;
        }
    }

</style>